import React, { useState, useEffect, useCallback } from 'react';
import { fetchCampaignSurveyAnalytics } from '../../api/client';
import CampaignSurveyAnalytics from '../CampaignSurveyAnalytics/CampaignSurveyAnalytics';
import CampaignSurveyList from '../CampaignSurveyList/CampaignSurveyList';

export default function CampaignSurveyTab() {
  const [analytics, setAnalytics] = useState(null);

  const loadAnalytics = useCallback(async () => {
    try {
      const res = await fetchCampaignSurveyAnalytics();
      setAnalytics(res.data);
    } catch (_e) {
      setAnalytics(null);
    }
  }, []);

  useEffect(() => {
    loadAnalytics();
  }, [loadAnalytics]);

  return (
    <div>
      <CampaignSurveyAnalytics analytics={analytics} />
      <CampaignSurveyList />
    </div>
  );
}
